/* eslint no-nested-ternary: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Calendar from 'react-calendar';
import moment from 'moment-timezone';
import {
  Segment,
  Grid,
  Button,
  Icon,
  Transition,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';
import { fromCalendarTile, toCalendarTile } from '../utils/calendarDate';
import TimePicker from './TimePicker';

moment.locale('en-gb');

class DateTimePicker extends Component {
  static propTypes = {
    basic: PropTypes.bool,
    closeable: PropTypes.bool,
    closeableCompact: PropTypes.bool,
    maxDate: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.instanceOf(Date),
    ]),
    minDate: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.instanceOf(Date),
    ]),
    noPadding: PropTypes.bool,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.instanceOf(Date),
    ]),
    visible: PropTypes.bool,
    onChange: PropTypes.func,
    useBrowserTimezone: PropTypes.bool,
  }
  static defaultProps = {
    visible: true,
    closeable: true,
    closeableCompact: true,
  }
  constructor(props) {
    super(props);
    const date = props.value;
    this.state = {
      date,
      loading: false,
      tabIndex: 1,
      transition: {
        calendar: true,
        time: false,
      },
      visible: props.visible,
    };
  }
  componentWillReceiveProps(nextProps) {
    const date = nextProps.value;
    this.setState({
      date,
      visible: nextProps.visible,
    });
  }
  setLoading = (loading = false) => {
    this.setState({
      loading,
    });
  }
  handleTabChange = (e, tabIndex) => {
    e.preventDefault();
    const transition = {
      calendar: tabIndex === 1,
      time: tabIndex === 2,
    };
    this.setState({
      tabIndex,
      loading: true,
    }, () => {
      this.setState({
        transition,
      });
    });
  }
  handleOnChangeTime = (date) => {
    const { visible } = this.state;
    this.setState({ date }, () => {
      if (this.props.onChange) this.props.onChange(date, visible);
    });
  }
  handleOnChangeCalendar = (value) => {
    const { visible, date } = this.state;
    const { useBrowserTimezone } = this.props;
    const newDate = fromCalendarTile(value, date, useBrowserTimezone).toDate();
    this.setState({ date: newDate }, () => {
      if (this.props.onChange) this.props.onChange(newDate, visible);
    });
  }
  handleOnClose = (e) => {
    e.preventDefault();
    const { date } = this.state;
    this.setState({ visible: false }, () => {
      if (this.props.onChange) this.props.onChange(date, this.state.visible);
    });
  }
  render() {
    const { loading, date, tabIndex, transition, visible } = this.state;
    const {
      basic, closeable, closeableCompact, maxDate, minDate, noPadding, t, useBrowserTimezone,
    } = this.props;
    const currentLang = (this.props.i18n && this.props.i18n.language) || 'en-GB';
    return (
      <Transition
        animation={'vertical flip'}
        duration={250}
        transitionOnMount
        unmountOnHide
        visible={visible}
      >
        <Grid centered>
          <Grid.Row style={noPadding && { paddingTop: '0' }}>
            <Grid.Column>
              <Segment basic={basic} className="dtp visible">
                <Button.Group fluid>
                  <Button
                    disabled={loading}
                    onClick={e => tabIndex === 2 && this.handleTabChange(e, 1)}
                    active={tabIndex === 1}
                    color={tabIndex === 1 ? 'teal' : null}
                  >
                    <Icon name="calendar" />
                    {t('Date')}
                  </Button>
                  <Button
                    disabled={loading}
                    onClick={e => tabIndex === 1 && this.handleTabChange(e, 2)}
                    active={tabIndex === 2}
                    color={tabIndex === 2 ? 'teal' : null}
                  >
                    <Icon name="clock" />
                    {t('Time')}
                  </Button>
                </Button.Group>
                {tabIndex === 1 &&
                  <Transition
                    animation={'scale'}
                    duration={250}
                    unmountOnHide
                    visible={transition.calendar}
                    onComplete={this.setLoading}
                    onHide={this.setLoading}
                  >
                    <Segment basic className="dtp_tab_content">
                      <Calendar
                        locale={currentLang}
                        maxDate={maxDate && toCalendarTile(maxDate, useBrowserTimezone)}
                        minDate={minDate && toCalendarTile(minDate, useBrowserTimezone)}
                        onChange={this.handleOnChangeCalendar}
                        value={toCalendarTile(date || moment(), useBrowserTimezone)}
                      />
                    </Segment>
                  </Transition>
                }
                {tabIndex === 2 &&
                  <Transition
                    animation={'scale'}
                    duration={250}
                    unmountOnHide
                    visible={transition.time}
                    onComplete={this.setLoading}
                    onHide={this.setLoading}
                  >
                    <Segment basic className="dtp_tab_content">
                      <TimePicker
                        value={date ? moment(date) : moment()}
                        onChange={this.handleOnChangeTime}
                        useBrowserTimezone={useBrowserTimezone}
                      />
                    </Segment>
                  </Transition>
                }
                {closeable && <Button size="small" primary fluid compact={closeableCompact} onClick={this.handleOnClose}>{t('Close', { ns: TRANSLATION_FILES.translation })}</Button>}
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Transition>
    );
  }
}

export default withTranslation(namespaces)(DateTimePicker);



// WEBPACK FOOTER //
// ./src/components/DateTimePicker.jsx